import { dataLayerPush } from '@/shared/analytics';

export const useViewAutoshipOrder = () => {
    const send = () => {
        dataLayerPush({ event: 'view_autoship_order', site_section: 'pdp' });
    };

    return { send };
};
